import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import SmartOrg from "./smart-org/smartOrg.vue";
import { StaffSelectorBase } from './staff-selector-base';
let StaffSelector = class StaffSelector extends StaffSelectorBase {
    treeFocus() {
        super.treeFocus();
    }
    mounted() {
        // console.log( this.options, 'options' ); 
    }
    // 树-返回
    onClickTrunBack() {
        super.onClickTrunBack();
    }
    // 树-下一级
    onClickNextHierarchy(val) {
        super.onClickNextHierarchy(val);
    }
    onClickBreadcrumb(val) {
        super.onClickBreadcrumb(val);
    }
    onChange(items) {
        super.onChange(items);
    }
    onOk(items) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            _super("onOk").call(this, items);
        });
    }
    onCancle() {
        super.onCancle();
    }
    onSearch(name) {
        super.onSearch(name);
    }
};
StaffSelector = tslib_1.__decorate([
    Component({
        name: "staff-selector",
        components: {
            SmartOrg
        },
        model: {
            event: "change",
            prop: "value"
        }
    })
], StaffSelector);
export default StaffSelector;
